


interface BeerIconProps {
	className?: string,
}


const BeerIcon = (props: BeerIconProps) => {
	const { className } = props;

	return (
		<svg
			aria-hidden="true"
			focusable="false"
			data-prefix="fas"
			data-icon="custom-beer-icon"
			className={`svg-inline--fa fa-custom-beer-icon${className ? ` ${className}` : ''}`}
			role="img"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 467 512">
			<path fill="currentColor" d="m405.28,80.73l-56.06,0l0,40.77l56.06,0c11.42,0 20.59,10.19 20.59,22.83l0,162.48c0,16.11 -6.12,32.01 -16.92,43.42c-10.6,11.21 -24.67,17.33 -39.55,17.33l-20.18,0l0,40.77l20.18,0c25.89,0 50.97,-11.01 69.11,-30.17c18.14,-19.16 28.13,-44.44 28.13,-71.35l0,-162.48c0,-35.06 -27.52,-63.6 -61.36,-63.6z"/>
			<path fill="currentColor" d="m298.25,0l-257.48,0c-22.42,0 -40.77,19.37 -40.77,43.22l0,425.46c0,23.85 18.35,43.22 40.77,43.22l257.68,0c22.42,0 40.77,-19.37 40.77,-43.22l0,-425.46c0,-23.85 -18.35,-43.22 -40.77,-43.22l-0.2,0zm-163.29,430.15c0,16.51 -13.45,29.97 -29.97,29.97s-29.97,-13.45 -29.97,-29.97l0,-348.4c0,-16.51 13.45,-29.97 29.97,-29.97s29.97,13.45 29.97,29.97l0,348.4zm128.84,0c0,16.51 -13.45,29.97 -29.97,29.97s-29.97,-13.45 -29.97,-29.97l0,-348.4c0,-16.51 13.45,-29.97 29.97,-29.97s29.97,13.45 29.97,29.97l0,348.4z"/>
		</svg>
	);
};

export default BeerIcon;